import { createContext, useContext, useReducer } from 'react';
import dayjs from 'dayjs';
import { SubmissionPublicationSearchState, SubmissionPublicationSearchReducer, ACTION_TYPES } from './submission-publication-search-reducer';
import { ISubmissionPublicationPagedRequest } from '../../../../model/sep/submission-publications/request/submission-publication-paged-request';
import ApplicationAppService from '../../../../application/platform/application-app-service';
import { toApiDate } from '../../../../utils/date';

const SubmissionPublicationSearchContext = createContext<SubmissionPublicationSearchState | undefined>(undefined);
const SubmissionPublicationSearchDispatchContext = createContext({} as any);

// Filtros padrão: remessas novas dos últimos 30 dias; usuário de entidade já filtra pela própria entidade
export const getDefaultSubmissionPublicationParameters = (): ISubmissionPublicationPagedRequest => {
    const authenticationData = ApplicationAppService.getAuthenticationData();
    return {
        startDate: toApiDate(dayjs().subtract(30, 'day')) ?? undefined,
        endDate: toApiDate(dayjs()) ?? undefined,
        id: undefined,
        statusId: [1],
        types: [1, 2],
        userSenderId: undefined,
        clientId: authenticationData?.type === 1 ? authenticationData.company.id : undefined,
        page: 0,
        pageSize: 25
    };
};

const SubmissionPublicationSearchProvider = ({ children }: { children: React.ReactNode }) => {
    const initialState: SubmissionPublicationSearchState = {
        users: [],
        status: [],
        parameters: getDefaultSubmissionPublicationParameters(),
        searchTrigger: 0
    };

    const [state, dispatch] = useReducer(SubmissionPublicationSearchReducer, initialState);

    return (
        <SubmissionPublicationSearchContext.Provider value={state}>
            <SubmissionPublicationSearchDispatchContext.Provider value={dispatch}>
                {children}
            </SubmissionPublicationSearchDispatchContext.Provider>
        </SubmissionPublicationSearchContext.Provider>
    );
}

const useSubmissionPublicationSearchState = () => {
    const context = useContext(SubmissionPublicationSearchContext);
    if (context === undefined) {
        throw new Error('useSubmissionPublicationSearchState must be used within a SubmissionPublicationSearchProvider');
    }
    return context;
}

const useSubmissionPublicationSearchDispatch = () => {
    const context = useContext(SubmissionPublicationSearchDispatchContext);
    if (context === undefined) {
        throw new Error('useSubmissionPublicationSearchDispatch must be used within a SubmissionPublicationSearchProvider');
    }
    return context;
}

export { SubmissionPublicationSearchProvider, useSubmissionPublicationSearchDispatch, useSubmissionPublicationSearchState, ACTION_TYPES };
